import { branch, nest } from 'recompose';
import AutoHeight from '../components/AutoHeight';

export default branch(
  ({ autoHeight }) => autoHeight,
  BaseComponent => nest(AutoHeight, BaseComponent)
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithAutoHeight.js